var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEncounterProgressAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 -0.000244141C18.6274 -0.00024443 24 5.37234 24 11.9998C24 18.6272 18.6274 23.9998 12 23.9998C5.37258 23.9998 2.89694e-07 18.6272 0 11.9998C-2.89694e-07 5.37234 5.37258 -0.000243851 12 -0.000244141Z",
    fill: "#70d6f8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45455 15.4923L6.73613 12.4319C6.4049 12.059 5.82237 12.059 5.49115 12.4319C5.211 12.7473 5.211 13.2224 5.49115 13.5378L9.45455 17.9998L18.5089 7.80642C18.789 7.49103 18.789 7.01595 18.5089 6.70056C18.1776 6.32766 17.5951 6.32766 17.2639 6.70056L9.45455 15.4923Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEncounterProgressAi);
export default __webpack_public_path__ + "static/media/Encounter-ProgressAI.8bb5bed9620337bde863709dfee4bfea.svg";
export { ForwardRef as ReactComponent };